(() => {
  const navButton = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (navButton && mobileNav) {
    navButton.addEventListener('click', () => {
      const next = navButton.getAttribute('aria-expanded') !== 'true';
      navButton.setAttribute('aria-expanded', String(next));
      mobileNav.classList.toggle('is-open', next);
      document.body.classList.toggle('menu-open', next);
    });
    mobileNav.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
      navButton.setAttribute('aria-expanded', 'false');
      mobileNav.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }));
  }

  document.querySelectorAll('[data-auto-submit]').forEach(select => {
    select.addEventListener('change', () => select.form?.requestSubmit());
  });

  const variantSelect = document.querySelector('[data-product-variant]');
  const price = document.querySelector('[data-price]');
  const add = document.querySelector('[data-add-to-cart]');
  if (variantSelect && price && add) {
    const update = () => {
      const option = variantSelect.selectedOptions?.[0];
      if (!option) return;
      price.textContent = option.dataset.price || price.textContent;
      const available = option.dataset.available === 'true';
      add.disabled = !available;
      add.textContent = available ? 'Add to cart →' : 'Sold out';
      const next = new URL(window.location.href);
      next.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', next);
    };
    variantSelect.addEventListener('change', update);
  }

  const mediaItems = Array.from(document.querySelectorAll('[data-product-media]'));
  const mediaButtons = Array.from(document.querySelectorAll('[data-media-thumb]'));
  mediaButtons.forEach(button => {
    button.addEventListener('click', () => {
      const id = button.dataset.mediaThumb;
      mediaItems.forEach(item => item.classList.toggle('is-hidden', item.dataset.productMedia !== id));
      mediaButtons.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });
    });
  });
})();
